/* Help Center hub — hero search over hub pages + every FAQ answer. */
(function () {
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function reEsc(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  var ICON_PAGE = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 3h7l4 4v14H7z"/><path d="M14 3v4h4M10 12h5M10 16h5"/></svg>';
  var ICON_Q = '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9.2 9.2a2.9 2.9 0 1 1 3.9 2.7c-.7.3-1.1.9-1.1 1.6v.5M12 17.2h.01"/><circle cx="12" cy="12" r="9"/></svg>';

  function init(root) {
    var input = root.querySelector('[data-hc-input]');
    var form = root.querySelector('[data-hc-form]');
    var box = root.querySelector('[data-hc-results]');
    var clear = root.querySelector('[data-hc-clear]');
    if (!input || !box) return;

    var lang = root.getAttribute('data-hc-lang') || 'en';
    var faqUrl = root.getAttribute('data-hc-faq-url') || '/pages/faq';
    var waHref = root.getAttribute('data-hc-wa') || '#';
    var pages = [], copy = {};
    try { pages = JSON.parse(root.querySelector('[data-hc-pages]').textContent); } catch (e) {}
    try { copy = JSON.parse(root.querySelector('[data-hc-copy]').textContent); } catch (e) {}

    var faq = null, loading = null;
    function loadFaq() {
      if (faq || loading) return loading;
      loading = fetch(root.getAttribute('data-hc-faq'))
        .then(function (r) { return r.json(); })
        .then(function (d) { faq = d[lang] || []; render(); })
        .catch(function () { faq = []; });
      return loading;
    }

    function render() {
      var q = input.value.toLowerCase().replace(/\s+/g, ' ').trim();
      clear.hidden = input.value.length === 0;
      if (q.length < 2) { box.hidden = true; box.innerHTML = ''; return; }
      var terms = q.split(' ');
      var re = new RegExp('(' + terms.map(reEsc).join('|') + ')', 'gi');
      function hasAll(h) { h = h.toLowerCase(); return terms.every(function (t) { return h.indexOf(t) !== -1; }); }
      function mark(s) { return esc(s).replace(re, '<mark>$1</mark>'); }

      var pHits = pages.filter(function (p) { return hasAll(p.n + ' ' + p.k); }).slice(0, 3);
      var fHits = [];
      (faq || []).forEach(function (it) {
        if (hasAll(it.q)) fHits.push({ it: it, s: 0 });
        else if (hasAll(it.q + ' ' + it.a)) fHits.push({ it: it, s: 1 });
      });
      fHits.sort(function (a, b) { return a.s - b.s; });
      fHits = fHits.slice(0, 5);

      var html = '';
      if (pHits.length) {
        html += '<div class="hc-res__h">' + esc(copy.pages || 'Pages') + '</div>';
        pHits.forEach(function (p) {
          html += '<a class="hc-res" href="' + esc(p.h) + '"><span class="hc-res__ic">' + ICON_PAGE + '</span><span><span class="hc-res__t">' + mark(p.n) + '</span></span></a>';
        });
      }
      if (fHits.length) {
        html += '<div class="hc-res__h">' + esc(copy.answers || 'Answers') + '</div>';
        fHits.forEach(function (h) {
          html += '<a class="hc-res" href="' + esc(faqUrl + '#' + h.it.s) + '"><span class="hc-res__ic">' + ICON_Q + '</span><span><span class="hc-res__t">' + mark(h.it.q) + '</span><span class="hc-res__s">FAQ · ' + esc(h.it.t) + '</span></span></a>';
        });
      }
      if (!html) {
        if (!faq) { box.hidden = true; return; }
        html = '<div class="hc-res__none">' + esc(copy.none || 'No answers yet for') + ' “' + esc(input.value.trim()) + '”. <a href="' + esc(waHref) + '" target="_blank" rel="noopener">' + esc(copy.ask || 'Ask our team on WhatsApp') + '</a></div>';
      }
      box.innerHTML = html;
      box.hidden = false;
    }

    input.addEventListener('focus', loadFaq, { once: true });
    input.addEventListener('input', function () { loadFaq(); render(); });
    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { input.value = ''; render(); }
      if (e.key === 'ArrowDown') {
        var first = box.querySelector('a');
        if (first) { e.preventDefault(); first.focus(); }
      }
    });
    box.addEventListener('keydown', function (e) {
      var links = Array.prototype.slice.call(box.querySelectorAll('a'));
      var i = links.indexOf(document.activeElement);
      if (i < 0) return;
      if (e.key === 'ArrowDown' && links[i + 1]) { e.preventDefault(); links[i + 1].focus(); }
      if (e.key === 'ArrowUp') { e.preventDefault(); (links[i - 1] || input).focus(); }
      if (e.key === 'Escape') { input.focus(); input.value = ''; render(); }
    });
    if (form) form.addEventListener('submit', function (e) {
      var first = box.querySelector('a.hc-res');
      e.preventDefault();
      if (first) window.location.href = first.href;
    });
    clear.addEventListener('click', function () { input.value = ''; render(); input.focus(); });
    root.querySelectorAll('[data-hc-pill]').forEach(function (b) {
      b.addEventListener('click', function () {
        input.value = b.getAttribute('data-hc-pill');
        loadFaq();
        render();
        input.focus();
      });
    });
    document.addEventListener('click', function (e) {
      if (!root.querySelector('.hc-finder').contains(e.target) && !e.target.hasAttribute('data-hc-pill')) box.hidden = true;
    });
    input.addEventListener('focus', function () { if (input.value.trim().length >= 2) render(); });
  }

  function boot() { document.querySelectorAll('[data-hc]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
